import SkeletonLoader from './index';

const SettingsSkeleton = () => {
  return (
    <div className="max-w-217 w-full">
      <SkeletonLoader width={200} height={32} />

      <div className="mt-6 border border-neutral-100 rounded-xl p-6">
        <div className="flex items-center justify-between mb-6">
          <SkeletonLoader width={180} height={24} />
          <div className="flex gap-3">
            <SkeletonLoader width={80} height={36} className="rounded-lg" />
            <SkeletonLoader width={120} height={36} className="rounded-lg" />
          </div>
        </div>

        <div className="space-y-6">
          {/* Avatar */}
          <SkeletonLoader variant="circle" width={100} height={100} />

          {/* Form Fields - Simulating the 3 column grid */}
          <div className="grid grid-cols-3 gap-8">
            {[1, 2, 3].map((i) => (
              <div key={i} className="space-y-2">
                <SkeletonLoader width={120} height={20} />
                <SkeletonLoader
                  width="100%"
                  height={40}
                  className="rounded-lg"
                />
              </div>
            ))}
          </div>

          <div className="grid grid-cols-2 gap-8">
            {[1, 2].map((i) => (
              <div key={i} className="space-y-2">
                <SkeletonLoader width={120} height={20} />
                <SkeletonLoader
                  width="100%"
                  height={40}
                  className="rounded-lg"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsSkeleton;
